// AudioListModal.tsx
import { X } from 'lucide-react';
import AudioPlayer from '../audioPlayer';
import { useEffect, useState } from 'react';
import { GET_DATA } from '../../services/API';
import LoadingAll from '../loadingAll';

export function AudioListModal({ isOpen, onClose, assistantId, externalReference }) {
  const [loading, setLoading] = useState(false);
  const [audiosUsuarios, setAudiosUsuarios] = useState([]);

  useEffect(() => {
    (async () => {
      try {
        if(!isOpen) {
          setAudiosUsuarios([]);
          return;
        }

        setLoading(true);
        const audios = await GET_DATA(`RequestOpenIA/GetAudiosSummaryByFilter?assistantId=${assistantId}&externalReference=${externalReference}&maxItens=20`);

        setAudiosUsuarios(audios.data);
        setLoading(false);

      } catch (error) {
        setLoading(false);
      }
    })();
  }, [externalReference, isOpen]);

  if (!isOpen && audiosUsuarios) return null;  

  const groups = audiosUsuarios?.reduce((acc, a) => {
    const day = new Date(a.dateCreate).toLocaleDateString();
    if (!acc[day]) acc[day] = [];
    acc[day].push(a);
    return acc;
  }, {});

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center">
      <div
        className="fixed inset-0 bg-black bg-opacity-50 backdrop-blur-sm"
        onClick={onClose}
      />

      {
        loading && <LoadingAll />
      }
      {
        !loading && <div className="relative z-10 bg-white dark:bg-gray-800 rounded-lg shadow-lg w-full max-w-2xl max-h-[80vh] overflow-y-auto p-6">
          <header className="flex items-center justify-between mb-4">
            <h2 className="text-lg font-semibold text-gray-900 dark:text-gray-100">Áudios</h2>
            <button onClick={onClose} className="p-1 hover:bg-gray-200 rounded-full dark:hover:bg-gray-700">
              <X className="w-6 h-6 text-gray-600 dark:text-gray-300" />
            </button>
          </header>

          {Object.entries(groups).map(([day, items]) => (
            <section key={day} className="mb-6">
              <h3 className="text-sm font-medium text-gray-700 dark:text-gray-300 mb-2">{day}</h3>
              <div className="space-y-2">
                {items.map(item => (
                  <AudioPlayer
                    key={item.id}
                    src={item.urlAudio}
                  />
                ))}
              </div>
            </section>
          ))}

          {audiosUsuarios.length === 0 && (
            <p className="text-center text-gray-500 dark:text-gray-400">Nenhum áudio disponível.</p>
          )}
        </div>
      }
    </div>
  );
}
